import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Po } from './po';
import { Poitem } from './poitem';
import { environment } from '../environments/environment';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class PoService {
  baseUrl = environment.baseUrl;
  private purchaseOrderUrl = this.baseUrl + '/api/purchase_order';  // URL to web api
  private getPOdetailsUrl = this.baseUrl + '/api/purchase_order/GetPODetails';
  private getPOInvocedetailsUrl = this.baseUrl + '/api/purchase_order/GetPOInvoiceDetails';
  private dashboardcountpoUrl = this.baseUrl + '/api/purchase_order/getdashboardcountpo';
  private awaitedpoUrl = this.baseUrl + '/api/purchase_order/getawaitedpo';
  private GetApprovalPOUrl = this.baseUrl + '/api/purchase_order/GetApprovalPO';
  private GetApprovalPOlevel1Url = this.baseUrl + '/api/purchase_order/GetApprovalPOlevel1';
  private GetPoStatusUrl = this.baseUrl + '/api/purchase_order/GetPoStatus';
  private addActionUrl = this.baseUrl + '/api/actions';
  private recentactionUrl = this.baseUrl + '/api/purchase_order/getrecentaction';
  private poitemsUrl = this.baseUrl + '/api/poitem';
  private getPOTrackingUrl = this.baseUrl + '/api/purchase_order/GetPoTrackingList';
  private getReviewerPoTrackingUrl = this.baseUrl + '/api/purchase_order/getReviewerPoTrackingList';
  private getRequestorPoTrackingUrl = this.baseUrl + '/api/purchase_order/getRequestorPoTrackingList';
  private getApprovalPoTrackingUrl = this.baseUrl + '/api/purchase_order/getApprovalPoTrackingList';
  private getUserPoTrackingUrl = this.baseUrl + '/api/purchase_order/getUserPoTrackingList';
  private getPoMatrixUrl = this.baseUrl + '/api/purchase_order/getapprovalmatrix';


  constructor(
    private http: HttpClient
  ) { }

  getPos(): Observable<Po[]> {
    return this.http.get<Po[]>(this.purchaseOrderUrl)
  }
  //for PO Tracking
  getPoTrackings(): Observable<Po[]> {
    return this.http.get<Po[]>(this.getPOTrackingUrl)
  }

  getUserPoTrackings(userid: number): Observable<Po[]> {
    return this.http.get<Po[]>(this.getUserPoTrackingUrl + "/" + userid)
  }

  getApprovalPoTrackings(userid: number): Observable<Po[]> {
    return this.http.get<Po[]>(this.getApprovalPoTrackingUrl + "/" + userid)
  }

  getRequestorPoTrackings(userid: number): Observable<Po[]> {
    return this.http.get<Po[]>(this.getRequestorPoTrackingUrl + "/" + userid)
  }

  getReviewerPoTrackings(userid: number): Observable<Po[]> {
    return this.http.get<Po[]>(this.getReviewerPoTrackingUrl + "/" + userid)
  }

  getApprovedPos(userid: number): Observable<Po[]> {
    return this.http.get<Po[]>(this.baseUrl + '/api/purchase_order/getapprovedpo/' + userid)
  }

  getAllApprovedPOList(): Observable<Po[]> {
    return this.http.get<Po[]>(this.baseUrl + '/api/purchase_order/getapprovedpo')
  }

  GetPOforInvoice(): Observable<Po[]> {
    return this.http.get<Po[]>(this.baseUrl + '/api/purchase_order/GetPOforInvoice')
  }

  GetPOforPayment(): Observable<Po[]> {
    return this.http.get<Po[]>(this.baseUrl + '/api/purchase_order/GetPOforPayment')
  }

  GetPOforInvoicePoCreator(userid: number): Observable<Po[]> {
    return this.http.get<Po[]>(this.baseUrl + '/api/purchase_order/GetPOforInvoice/' + userid)
  }

  getCurrency(): Observable<any[]> {
    return this.http.get<any[]>(this.baseUrl + '/api/purchase_order/GetCurrency')
  }



  /* PO Details */
  GetPOInvoiceDetails(poid: number): Observable<Po> {
    const url = `${this.getPOInvocedetailsUrl}/${poid}`;
    return this.http.get<Po>(url);
  }

  GetRecentPurchaseOrders(): Observable<Po[]> {
    return this.http.get<Po[]>(this.baseUrl + '/api/purchase_order/GetRecentPurchaseOrders')
  }
  GetAllRecentPurchaseOrders(): Observable<Po[]> {
    return this.http.get<Po[]>(this.baseUrl + '/api/purchase_order/GetAllRecentPurchaseOrders')
  }

  getRejectedPos(userid: number): Observable<Po[]> {
    return this.http.get<Po[]>(this.baseUrl + "/api/purchase_order/getrejectedpo/" + userid)
  }


  GetUserPurchaseOrder(userid: number): Observable<Po[]> {
    const url = `${this.purchaseOrderUrl}/GetPoList/${userid}`;
    return this.http.get<Po[]>(url)
  }

  GetReviwerPurchaseOrder(userid: number): Observable<Po[]> {
    const url = `${this.purchaseOrderUrl}/GetReviewerPoList/${userid}`;
    return this.http.get<Po[]>(url)
  }

  GetRequestorPurchaseOrder(userid: number): Observable<Po[]> {
    const url = `${this.purchaseOrderUrl}/GetRequestorPoList/${userid}`;
    return this.http.get<Po[]>(url)
  }

  getdepartment(): Observable<Po[]> {
    return this.http.get<Po[]>(this.baseUrl + '/api/department')
  }
  getrequester(): Observable<Po[]> {
    return this.http.get<Po[]>(this.baseUrl + '/api/user/requestors')
  }

  getPo(poid: number): Observable<Po> {
    const url = `${this.purchaseOrderUrl}/${poid}`;
    return this.http.get<Po>(url);
  }

  /* PO Details */
  GetPODetails(poid: number): Observable<Po> {
    const url = `${this.getPOdetailsUrl}/${poid}`;
    return this.http.get<Po>(url);
  }

  /* Dashboard values*/
  getDashboardCountsPO(userid: number): Observable<Po[]> {
    const url = `${this.dashboardcountpoUrl}/${userid}`;
    return this.http.get<Po[]>(url)
  }
  /*Awaited PO list for Po Approver dashboard */
  getAwaitedPO(userid: number): Observable<Po[]> {
    const url = `${this.awaitedpoUrl}/${userid}`;
    return this.http.get<Po[]>(url)
  }

  GetApprovalPO(userid: number): Observable<Po[]> {
    const url = `${this.GetApprovalPOUrl}/${userid}`;
    return this.http.get<Po[]>(url)
  }
  GetApprovalPOlevel1(userid: number): Observable<Po[]> {
    const url = `${this.GetApprovalPOlevel1Url}/${userid}`;
    return this.http.get<Po[]>(url)
  }
  /*Recent Action on PO list for Po Approver dashboard */
  getApproverRecentAction(): Observable<Po[]> {
    return this.http.get<Po[]>(this.recentactionUrl)
  }


  /*PO status for PO Approver detail page */
  GetPoStatus(): Observable<Po[]> {
    return this.http.get<Po[]>(this.GetPoStatusUrl)
  }
  //addAction is for PO Approver page status update
  addAction(po: Po): Observable<Po> {
    return this.http.post<Po>(this.addActionUrl, po, httpOptions);
  }

  addPo(po: Po): Observable<Po> {
    return this.http.post<Po>(this.purchaseOrderUrl, po, httpOptions);
  }

  addPoItem(poitem: Poitem): Observable<Po> {
    return this.http.post<Po>(this.baseUrl + '/api/poitem', poitem, httpOptions);
  }

  updatePoItem(poitem: Poitem): Observable<any> {
    return this.http.put(this.baseUrl + '/api/poitem', poitem, httpOptions);
  }

  deletePoItem(poitemid: number): Observable<Po> {

    const url = `${this.poitemsUrl}/${poitemid}`;

    return this.http.delete<Po>(url, httpOptions);
  }

  deletePo(po: Po | number): Observable<Po> {
    const poid = typeof po === 'number' ? po : po.poid;
    const url = `${this.purchaseOrderUrl}/${poid}`;

    return this.http.delete<Po>(url, httpOptions);
  }

  updatePo(po: Po): Observable<any> {
    return this.http.put(this.purchaseOrderUrl, po, httpOptions);
  }
  getPoMatrix(userid: number): Observable<Po[]> {
    return this.http.get<Po[]>(this.getPoMatrixUrl + "/" + userid)
  }

}